import { useOptionalPrivanaI18n } from '@/i18n/PrivanaI18nProvider'
import React from 'react'

export default function MemberPaymentMethodOptions({ value = 'member_account', onChange, disabled = false, includeGuestPay = false, mobileCards = false, localised = true }) {
  const { t: translate } = useOptionalPrivanaI18n()
  const t = translate
  const selected = value === 'pay_now' ? 'pay_now' : value === 'guest_online' ? 'guest_online' : 'member_account'
  const handleChange = (event) => {
    if (disabled) return
    onChange?.(event.target.value)
  }

  return (
    <div className={`mp-summary-section mp-payment-section${mobileCards ? ' mp-payment-section--mobile-cards' : ''}`}>
      <p className="mp-label">{t('facilityBooking.payment')}</p>
      <div className="mp-payment-options">
        <label className={`mp-payment${selected === 'member_account' ? ' is-selected' : ''}`}>
          <input type="radio" name="payment" value="member_account" checked={selected === 'member_account'} onChange={handleChange} disabled={disabled} />
          <div>
            <div className="mp-value">{t('facilityBooking.account')}</div>
            <p className="mp-text-muted">{t('facilityBooking.statement')}</p>
          </div>
        </label>
        <label className={`mp-payment${selected === 'pay_now' ? ' is-selected' : ''}`}>
          <input type="radio" name="payment" value="pay_now" checked={selected === 'pay_now'} onChange={handleChange} disabled={disabled} />
          <div>
            <div className="mp-value">Privana Pay</div>
            <p className="mp-text-muted">{t('facilityBooking.secure')}</p>
          </div>
        </label>
        {includeGuestPay ? (
          <label className={`mp-payment${selected === 'guest_online' ? ' is-selected' : ''}`}>
            <input type="radio" name="payment" value="guest_online" checked={selected === 'guest_online'} onChange={handleChange} disabled={disabled} />
            <div>
              <div className="mp-value">{t('facilityBooking.guestPay')}</div>
              <p className="mp-text-muted">{t('facilityBooking.guestLink')}</p>
            </div>
          </label>
        ) : null}
      </div>
    </div>
  )
}
